import styled from "styled-components";
import PropTypes from "prop-types";

const StyledContainer = styled.div`
  width: 100%;
  height: auto;
  max-width: 1400px;
  padding: 0 15px;
  ${({vCentered}) => vCentered && `
    display: flex;
    align-items: center;
  `}
  ${({hCentered}) => hCentered && `
    display: flex;
    justify-content: center;
  `}
`

const Container = ({...props}) => {
  return (
    <StyledContainer {...props}/>
  );
};

export default Container;

Container.propTypes = {
  vCentered: PropTypes.bool,
  hCentered: PropTypes.bool,
};